import { useState, useEffect, useRef } from 'react';
import { postData, getData } from '../../../../ApiServices/ApiService';
import { ORG_GET_TASK_LIST } from '../../../../ApiServices/BaseURL';
import { useNavigate } from 'react-router-dom';
import { ORG_DELETE_CLIENT_TASK } from '../../../../ApiServices/BaseURL';
import { useTheme } from '../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../Utils/Exception';

const ClientTaskListController = (taskList, responseError, responseLoading, fetchTaskList,clientId) => {
  // console.log("responseLoading", responseLoading);
  // console.log("taskList", taskList);
  const { setIsLoginPopup } = useTheme();
  const [tasks, setTasks] = useState(taskList || []);
  const [filteredTasks, setFilteredTasks] = useState(taskList || []);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [loading, setLoading] = useState(responseLoading || false)
  const [error, setError] = useState(responseError || '');
  const navigate = useNavigate();
  const [deleteTaskLoading, setDeleteTaskLoading] = useState({});
  const [deleteTaskError, setDeleteTaskError] = useState({});
  const [deleteTaskSuccess, setDeleteTaskSuccess] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const taskInfoRef = useRef(null)
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [checkedStates, setCheckedStates] = useState([]);

   const pageName = 'ClientTaskList';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;



  useEffect(() => {
    setFilteredTasks(taskList);
  }, [taskList]);

  useEffect(() => {
    
    console.log("responseLoading in useEffect", responseLoading);
    setLoading(responseLoading);
    setError(responseError);
  }, [responseLoading, responseError]);

  const fetchTaskList2 = async () => {
    //console.log('get client')
    try {
      setFilteredTasks([])
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id
      }
      const response = await postData(ORG_GET_TASK_LIST, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setTasks(responseData?.dataJ);
              setFilteredTasks(responseData?.dataJ);
            } else {
              setError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "", responseData?.info || '');
            }
          } else {
            setError(responseData?.info || 'Failed to fetch data. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Something went wrong while processing your request.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  }

  const toggleDetails = (index) => {
    setFilteredTasks((prevTasks) =>
      prevTasks.map((task, i) =>
        i === index ? { ...task, showDetails: !task.showDetails } : task
      )
    );
  };

  const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTasks = filteredTasks.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const getStatusStyle = (status) => {
    switch (true) {
      case status?.task_status_name?.toLowerCase() === 'delayed':
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
      case status?.task_status_name?.toLowerCase() === 'not started':
        return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
      case status?.task_status_name?.toLowerCase() === 'in progress':
        return { backgroundColor: "#d4edda", color: "#155724" }; // Green
      case status?.task_status_name?.toLowerCase() === 'completed':
        return { backgroundColor: "#c7c4c32e", color: "#7b7b7b" }; // Gray
      case status?.task_status_name?.toLowerCase() === 'priority':
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
      case status?.task_status_name?.toLowerCase() === 'hold':
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
      case status?.task_status_name?.toLowerCase() === 'issue':
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
      case status?.task_status_name?.toLowerCase() === 'overdue':
        return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red

      default:
        return {};
    }
  };
  const handleSelectAll = (isChecked) => {
    setSelectAll(isChecked);
    // setCheckedStates(filteredTasks.map(() => isChecked));
    // setCheckedStates(taskList.map(() => isChecked));
    // Update taskList to mark all as checked or unchecked
    const updatedTaskList = filteredTasks.map((task) => ({
        ...task,
        checked: task?.invoice_gen_status !== 1 ? isChecked : false,
    }));
    setFilteredTasks(updatedTaskList);


    if (isChecked) {
        // Add all task IDs to the selectedTaskIds list
        setSelectedTaskIds(
          filteredTasks
              .filter(task => task?.invoice_gen_status !== 1)
              .map(task => task?.task_id)
      );

     
    } else {
        // Clear the selectedTaskIds list
        setSelectedTaskIds([]);

    }
  };

  const handleCheckboxChange = (isChecked, taskId) => {
    // Update the checked status of the task based on taskId
    const updatedTaskList = filteredTasks.map((task) =>
        task.task_id === taskId ? { ...task, checked: isChecked, task_id: taskId } : task
    );

    setFilteredTasks(updatedTaskList);

    // Manage selected task IDs
    setSelectedTaskIds((prev) => {
        const updatedTaskIds = isChecked
            ? [...prev, taskId] // Add taskId if checked
            : prev.filter((id) => id !== taskId); // Remove taskId if unchecked

        return [...new Set(updatedTaskIds)]; // Ensure no duplicates
    });

    // Check if all **non-invoiced (`invoice_gen_status === 0`)** tasks are checked
    const allChecked = updatedTaskList
        .filter(task => task.invoice_gen_status === 0) // ✅ Consider only valid tasks
        .every(task => task.checked);

    setSelectAll(allChecked);
};



  const handleGenerateInvoive = () => {
    setError('');
    // Find items where checked === true and invoice_amt_agreed < 1
    const invalidTasks = filteredTasks
        .filter(item => item.checked === true && item.invoice_amt_agreed < 1)
        .map(item => item.task_id); // Extract only task_id for error message

    if (invalidTasks.length > 0) {
      setError(`The selected task(s) doesn’t have agreed amount: Task ID - ${invalidTasks.join(", ")}`)
        return; // Stop execution
    }
    const selectedTaskList = selectedTaskIds.map((id, index) => ({
      task_id: id,
  }));
  console.log('clientId:',selectedTaskList)
    // var selectedClient = {
    //   client_id:clientId?.client_id,
    //   client_name:clientId?.client_name,
    // }
    const preInvoiceData = {
      "clientSelectedInfo": clientId,
      "groupInfo": {},
      "groupClient":null,
      "generatedBy":null,
      "systemBillingAmount":0,
      "estimateAmount":0,
      "send_update_client": false,
      "send_update_team": false,
      "tasks_list_selected": selectedTaskList,
      "services_list_selected": [],
      "estimate_for": 'Client',
      "estimate_type": true,
      "groupTaskList": [],
      "taskList": [],
      "pageType": 'taskListPage'
  }
  console.log('preInvoiceData:-', preInvoiceData);

  navigate('/generate-invoice', { state: { rowData: null, pageType: 'taskList', preInvoiceData: preInvoiceData } });
};

  const onTaskDelete = async (taskInfo) => {
    //console.log('taskInfo:-', taskInfo?.task_id);
    taskInfoRef.current = taskInfo;
    setIsDeleteModalOpen(true);

  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
  }
  const callDeleteTask = async (taskInfo) => {
    try {
      setDeleteTaskError({});
      setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: '' }));
      setDeleteTaskLoading((prev) => ({ ...prev, [taskInfo?.task_id]: true }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "task_id": taskInfo?.task_id
      }

      //console.log('callDeleteTask payload', payLoad);

      // Make the API call
      const response = await postData(ORG_DELETE_CLIENT_TASK, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteTaskSuccess((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info }));
            setTimeout(() => {
              setDeleteTaskSuccess((prev) => ({ ...prev, [taskInfo?.task_id]: '' }));
              fetchTaskList();
            }, 3000);
          } else {
            setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info || 'Failed to delete task. Please try again.' }));
            logFrontendException(storedUserId, pageName, "callDelete", responseData?.info || '');
          }
        } else {
          setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: responseData?.info || 'Failed to delete task. Please try again...' }));
          logFrontendException(storedUserId, pageName, "callDelete", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        
          setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
        logFrontendException(storedUserId, pageName, "callDelete", responseData || '');
        setIsLoginPopup(true)
      }
      
      // Unexpected or network-related errors
      else {
        setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: 'Unexpected error occurred. Please try again later.' }));
        logFrontendException(storedUserId, pageName, "callDelete", responseData || '');
      }
    } catch (error) {
      
        setDeleteTaskError((prev) => ({ ...prev, [taskInfo?.task_id]: `Failed to delete task. Please check your network connection and try again.` }));
      logFrontendException(storedUserId, pageName, "callDelete-catch", error || '');
    } finally {
      setDeleteTaskLoading((prev) => ({ ...prev, [taskInfo?.task_id]: false }));
    }
  }

  const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

  return {
    tasks: currentTasks,
    currentPage,
    totalPages,
    handlePageChange,
    toggleDetails,
    getStatusStyle,
    loading,
    error,
    handleGenerateInvoive,
    onTaskDelete,
    deleteTaskError, deleteTaskLoading, deleteTaskSuccess,
    isDeleteModalOpen, handleCloseDeleteModal,
    callDeleteTask,selectAll,checkedStates,handleSelectAll,handleCheckboxChange,
    taskInfoRef,
    visiblePages,
    selectedTaskIds
  };
};

export default ClientTaskListController;
